import { ReferralRewardSettingsModel, RewardModel } from '@shared/types';
import { transformRewardsFromObjectToMap } from '@shared/utils';

import { ReferralRewardSettingsFormValues } from '../ReferralRewardSettingsForm';

export const getReferralSystemEditFormInitialValues = (
  referralRewardSettings: ReferralRewardSettingsModel,
  initialRewards: RewardModel[]
): ReferralRewardSettingsFormValues => {
  const { id, rewardsChances, referralValidationRewards, ...restDetails } = referralRewardSettings;

  return {
    ...restDetails,
    rewardsChances: transformRewardsFromObjectToMap(rewardsChances, initialRewards),
  };
};
